import { ParsedUrlQuery } from 'querystring';

import { GetServerSidePropsContext, PreviewData } from 'next';

import { TOKEN_COOKIE_NAME } from '@/auth/constants';
import { LOGIN_URL } from '@/constants/routes';

export const getNoTokenRedirectProps = (
	context: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>,
) => {
	const token = context.req.cookies[TOKEN_COOKIE_NAME];
	if (!token) {
		return {
			redirect: {
				destination: LOGIN_URL,
			},
			props: {},
		};
	} else return null;
};
